export type SeasonalTheme = 'halloween' | 'thanksgiving' | 'christmas' | 'cny' | 'valentine' | 'pride' | 'birthday' | 'default'

export interface SeasonalAssets<T = any> {
  halloween?: T
  thanksgiving?: T
  christmas?: T
  cny?: T
  valentine?: T
  pride?: T
  birthday?: T
  default: T
}

/**
 * Gets the current active seasonal theme based on feature flags
 * Priority order: Valentine > CNY > Christmas > Thanksgiving > Halloween > Default
 */
export function getActiveTheme(flags: {
  isHalloween?: boolean
  isThanksgiving?: boolean
  isChristmas?: boolean
  isCNY?: boolean
  isValentine?: boolean
  isPride?: boolean
  isBirthday?: boolean
}): SeasonalTheme {
  if (flags.isBirthday) return 'birthday'
  if (flags.isPride) return 'pride'
  if (flags.isCNY) return 'cny'
  if (flags.isValentine) return 'valentine'
  if (flags.isChristmas) return 'christmas'
  if (flags.isThanksgiving) return 'thanksgiving'
  if (flags.isHalloween) return 'halloween'
  return 'default'
}

/**
 * Selects the appropriate asset based on the active seasonal theme
 */
export function getSeasonalAsset<T>(theme: SeasonalTheme, assets: SeasonalAssets<T>): T {
  return assets[theme] ?? assets.default
}

/**
 * Helper to get both theme and asset in one call
 */
export function useSeasonalAsset<T>(
  flags: {
    isHalloween?: boolean
    isThanksgiving?: boolean
    isChristmas?: boolean
    isCNY?: boolean
    isValentine?: boolean
    isPride?: boolean
    isBirthday?: boolean
  },
  assets: SeasonalAssets<T>
): { theme: SeasonalTheme; asset: T } {
  const theme = getActiveTheme(flags)
  const asset = getSeasonalAsset(theme, assets)
  return { theme, asset }
}
